import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Container,
  Paragraph,
  Card,
  SmallText,
  Button
} from '../../../legacy/hui/src/styled';
import Cleave from 'cleave.js/react';
import { Theme } from '../Bunnings/Theme';
import styled from 'styled-components';
import { ButtonSubmit } from '../Bunnings/Buttons';
import Loader from '../Loader';

import Field, { ErrorText } from '../Field';
import { Field as ReduxField, reduxForm, Form } from 'redux-form';
import { InstallModal } from '../Modals/InstallModal';
import { InfoModal } from '../Modals/InfoModal';
import { formatDate, parseDate } from 'react-day-picker/moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import dateIcon from '../../images/purchase-icon.svg';
import info from '../../images/information.svg';
import logo from '../../images/hipages-logo.svg';
import questionIcon from '../../images/question-icon.svg';
import { pdateValidation, voucherValidation } from '../../utils/validation';
import { NoVoucher } from './ModalContent';
import { FourteenCode } from './FourteenCode';
import { ReceiptCode } from './ReceiptCode';

export const QuestionLogo = styled.div`
  width: 16px;
  height: 16px;
  background: url(${questionIcon}) no-repeat;
  text-indent: -99999px;
  display: inline-block;
  background-size: contain;
  margin-right: 0.5rem;
`;

export const InfoLogo = styled.div`
  width: 25px;
  height: 25px;
  min-width: 25px;
  background: url(${info}) no-repeat;
  text-indent: -99999px;
  display: inline-block;
  background-size: contain;
  margin-right: 0.5rem;
`;

export const InfoText = styled.div`
  font-size: 15px;
  color: #434447;
  line-height: 22px;
`;

const QuestionLink = styled.a`
  color: #555659;
  text-decoration: underline;
  cursor: pointer;
`;

export const InstallParagraph = styled.p`
  font-size: 20px;
  color: #434447;
  line-height: 35px;
  margin-bottom: 0;
  ${props => (props.center ? 'text-align: center;' : 'text-align: left;')};

  b {
    font-weight: 600;
  }
`;

const InstallPanelTitle = Paragraph.extend`
  font-size: 19px;
  color: #555659;
  line-height: 1.5;
  margin-top: 5px;
  span {
    color: ${Theme.primary};
  }
`;

const InputWrapper = styled.div`
  input {
    border: 1px solid #a1a1a3;
    border-radius: 5px;
    padding: 13px 15px;
    width: 100%;
    outline: none;
    text-align: center;
  }
  &.errorBorder input {
    border: 1px solid #ca3121;
  }
  &.normalBorder input {
    border: 1px solid #a1a1a3;
  }
`;

export const VouchImg = styled.img`
  width: 100%;
  max-width: 520px;
`;

const LogoWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
  text-align: center;
  p,
  img {
    display: inline-block;
  }

  p {
    margin-right: 20px;
    color: #a1a1a3;
    padding-top: 10px;
  }

  img {
    vertical-align: top;
  }
`;

const TitleText = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #434447;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  font-family: roboto !important;
`;

const DayPickerInputWrapper = styled.div`
  position: relative;
  .DayPickerInput {
    width: 100%;
  }

  input {
    width: 100%;
    font-size: 16px;
    appearance: none;
    outline: 0;
    border-radius: 5px;
    padding: 12px 15px 12px 45px;
    border: 1px solid #a1a1a3;
    background-image: url(${dateIcon});
    background-repeat: no-repeat;
    background-position: left 10px center;
  }
  &.errorBorder input {
    border: 1px solid #ca3121;
  }
  &.normalBorder input {
    border: 1px solid #a1a1a3;
  }
  .DayPickerInput-Overlay {
    @media (min-width: ${props => props.theme.breakpoints.lg}rem) {
      margin-left: -80px;
    }
  }
`;
const DatePickField = ({ input, meta }) => (
  <DayPickerInputWrapper className={meta.error && meta.touched ? 'errorBorder' : 'normalBorder'}>
    <DayPickerInput
      format="DD/MM/YYYY"
      inputProps={{ ...input }}
      placeholder="DD/MM/YYYY"
      formatDate={formatDate}
      parseDate={parseDate}
      onDayChange={day => {
        input.onChange(formatDate(day));
      }}
    />
    {meta.error && meta.touched && typeof meta.error === 'string' && (
      <ErrorText style={{ paddingBottom: 0 }}>{meta.error}</ErrorText>
    )}
  </DayPickerInputWrapper>
);
DatePickField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object
};

export const LicenceText = styled.p`
  text-align: center;
  display: block;
  font-size: 12px;
  color: #434447;
  line-height: 22px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    font-size: 15px;
  }
`;
const renderCleaveField = ({ input, meta }) => (
  <InputWrapper className={meta.error && meta.touched ? 'errorBorder' : 'normalBorder'}>
    <Cleave
      {...input}
      placeholder="XXX - XXXXX - XXXX - XXXX - XX - XX"
      options={{ blocks: [3, 5, 4, 4, 2, 2], delimiter: ' - ', uppercase: true }}
    />
    {meta.error && meta.touched && typeof meta.error === 'string' && (
      <ErrorText style={{ paddingBottom: 0 }}>{meta.error}</ErrorText>
    )}
  </InputWrapper>
);
renderCleaveField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object
};

const errorMessage = ({ meta }) => {
  return meta.error ? <ErrorText style={{ paddingBottom: 0 }}>{meta.error}</ErrorText> : null;
};
errorMessage.propTypes = {
  meta: PropTypes.object
};

const Action = styled.div`
  height: 18px;
  display: flex;
  align-items: center;
  margin-top: 2rem;
  width: 100%;
  justify-content: center;
`;

const ColAlt = Col.extend`
  display: flex;
  align-items: flex-start;
`;

export const CodeAction = ({ action, modalKey, title }) => (
  <Action>
    <QuestionLogo />
    <QuestionLink onClick={() => action(modalKey)}>{title}</QuestionLink>
  </Action>
);

CodeAction.propTypes = {
  action: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

class CheckCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noVoucherModalOpen: false,
      altVoucher: false
    };
  }

  openInfoModal = key => {
    this.setState({ [key]: true });
  };

  closeInfoModal = key => {
    this.setState({ [key]: false });
  };

  switchVoucher = key => {
    this.setState(prev => ({
      [key]: false,
      altVoucher: !prev.altVoucher
    }));
  };

  render() {
    const { install, backToFirstScreen, handleSubmit, continueToEnquire } = this.props;
    const { closeInfoModal, openInfoModal, switchVoucher } = this;
    const { loading, used, success, pending, categories } = install;
    const { differentCodeModalOpen, noVoucherModalOpen, altVoucher, isOpen } = this.state;
    const installCodeSize = altVoucher ? 12 : 7;
    return (
      <Container pl={0} pr={0}>
        <InstallModal
          continueToEnquire={continueToEnquire}
          isOpen={success}
          categories={categories}
        />
        <InfoModal
          switchVoucher={switchVoucher}
          isOpen={noVoucherModalOpen}
          modalKey="noVoucherModalOpen"
          closeInfoModal={closeInfoModal}
          title={`I didn't get an installation voucher`}
        >
          <NoVoucher />
        </InfoModal>
        <Row mt={4} mb={2} gutter={0}>
          <Col xs={12} md={6} pb={2} pr={{ xs: 0, md: 2 }} gutter={0}>
            {altVoucher ? (
              <Fragment>
                <ReceiptCode />
                <CodeAction
                  title={'My install code looks different'}
                  action={switchVoucher}
                  modalKey="noVoucherModalOpen"
                />
              </Fragment>
            ) : (
              <Fragment>
                <FourteenCode />
                <CodeAction
                  title={'My receipt looks different'}
                  action={openInfoModal}
                  modalKey="noVoucherModalOpen"
                />
              </Fragment>
            )}
          </Col>
          <Col xs={12} md={6} pl={{ xs: 0, md: 2 }} gutter={0}>
            <Card snow pl={2} pr={2} pt={1.5} pb={2} mt={0}>
              <Form onSubmit={handleSubmit}>
                {success && <ButtonSubmit mb={3}>Success!!! Go to next page</ButtonSubmit>}
                {pending && (
                  <div>
                    <InstallPanelTitle>
                      {' Whether you are starting a new job or checking in on one underway,'}
                      <span>
                        {' '}
                        enter your install code{altVoucher ? false : ' and purchase date'}
                      </span>
                    </InstallPanelTitle>
                    <Row>
                      <Col xs={12} lg={installCodeSize} mt={0.63}>
                        <TitleText>Install Code</TitleText>
                        <ReduxField
                          name="install_voucher"
                          component={renderCleaveField}
                          validate={[voucherValidation]}
                        />
                      </Col>
                      <Col xs={12} lg={5} mt={0.63}>
                        {altVoucher ? (
                          false
                        ) : (
                          <Fragment>
                            <TitleText>Purchase Date</TitleText>
                            <ReduxField
                              name="pdate"
                              component={DatePickField}
                              validate={[pdateValidation]}
                              autoComplete="new-password"
                            />
                          </Fragment>
                        )}
                      </Col>
                      <Col xs={12}>
                        <ReduxField name="install_voucher_error" component={errorMessage} />
                      </Col>
                    </Row>
                    <Row mt={1.5}>
                      <ColAlt xs={12}>
                        <InfoLogo />
                        <InfoText>
                          If you&apos;re booking multiple installs enter any of your install codes
                          to get started.
                        </InfoText>
                      </ColAlt>
                    </Row>
                    <Row mt={0.3}>
                      <ColAlt xs={12}>
                        <InfoLogo />
                        <InfoText>
                          If you&apos;ve already started your job, you can find your install code in
                          the first email we sent you.
                        </InfoText>
                      </ColAlt>
                    </Row>
                    <ButtonSubmit mt={1.5}>{loading ? <Loader /> : 'Go'}</ButtonSubmit>
                    {altVoucher ? (
                      false
                    ) : (
                      <Row>
                        <CodeAction
                          title={`I didn't get an installation voucher`}
                          action={openInfoModal}
                          modalKey="noVoucherModalOpen"
                        />
                      </Row>
                    )}
                  </div>
                )}
                {used && (
                  <div>
                    <InstallPanelTitle>
                      This code has been used already
                      <br />
                      <span>Enter your email address to see your job</span>
                    </InstallPanelTitle>
                    <Field label="" name="install_email" />
                    <ButtonSubmit mt={0}>{loading ? <Loader /> : 'Continue'}</ButtonSubmit>
                    <Button
                      dark
                      block
                      ghost
                      mt={1.5}
                      mb={0}
                      style={{ borderRadius: '5px' }}
                      onClick={backToFirstScreen}
                    >
                      Back
                    </Button>
                  </div>
                )}
              </Form>
              <LogoWrapper>
                <SmallText>Powered by</SmallText>
                <img src={logo} />
              </LogoWrapper>
            </Card>
          </Col>
        </Row>
        <Row mb={1}>
          <Col xs={12}>
            <InstallParagraph center style={{ marginBottom: '16px' }}>
              Need a hand?{' '}
              <span style={{ fontWeight: '600', whiteSpace: 'nowrap' }}>Call 1300 043 520</span>
            </InstallParagraph>
            <LicenceText>
              {`Bunnings Group Limited requires builders’ licences in certain circumstances and is licensed as follows:`}
              <br />
              {`SA: Builder Licence No: BLD 248065;`}
              <br />
              {`QLD: QBCC Act Licence No: 1191280;`}
              <br />
              {`VIC Security Licence No: 954-386-50S`}
              <br />
              {`QLD Security Licence No: 4251838`}
              <br />
              {`NSW: Builder Licence No: 186807C Tel: (03) 8831 9777`}
            </LicenceText>
          </Col>
        </Row>
      </Container>
    );
  }
}
/*
SA: Builder Licence No: BLD 248065;
QLD: QBCC Act Licence No: 1191280;
NSW: Builder Licence No: 186807C Tel: (03) 8831 9777
VIC Security Licence No: 954-386-50S
QLD Security Licence No: 4251838
*/

CheckCode.propTypes = {
  install: PropTypes.object,
  handleSubmit: PropTypes.func,
  continueToEnquire: PropTypes.func,
  backToFirstScreen: PropTypes.func,
  checkInstallEmail: PropTypes.func,
  checkInstallCode: PropTypes.func
};

export default reduxForm({
  form: 'InstallForm'
})(CheckCode);
